import {StyleSheet, View} from "react-native";
import React from "react";
import {JobRowDetailV2} from "./index";
import shallowEqual from "shallowequal";
import commonStyles from "../styles";

interface IJobRowAsHeaderProps {
    workshopJobRow: any;
    actionContent?: JSX.Element;
    showActionContent?: boolean;
    disableBottomRadius?: boolean;
}

const JobRowAsHeader = (props: IJobRowAsHeaderProps) => {
    const {workshopJobRow, disableBottomRadius, showActionContent} = props;
    return <View style={[commonStyles.cardOne, disableBottomRadius ? {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
    } : null]}>
        <View style={[styles.row]}>
            <View style={{minWidth: '50%', marginLeft: 5}}>
                <JobRowDetailV2 jobRow={!!workshopJobRow ? workshopJobRow : null}/>
            </View>
            {
                showActionContent ? <View style={{
                    flexDirection: "row",
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    flex: 1
                }}>
                    {props.actionContent}
                </View> : null
            }
        </View>
    </View>;
};

const areEqual = function areEqual(prevProps, nextProps) {
    return JSON.stringify({...prevProps, actionContent: null}) === JSON.stringify({...nextProps, actionContent: null}) && shallowEqual(prevProps.actionContent, nextProps.actionContent)
};

export default React.memo(JobRowAsHeader, areEqual);

const styles = StyleSheet.create({
    row: {
        flex: 1,
        flexDirection: 'row'
    }
})